import AlertFilled from "chameleon/icons/alert-filled";
import { Text } from "chameleon/lib/components/text/text";

import { wrapper } from "./inline-message-styles.css";

interface InlineMessageProps {
  /**
   * Message to display
   */
  message?: string;
  /**
   * type
   */
  type?: "error" | "info";
  /**
   * ID for accessibility purposes
   */
  id: string;
}

/**
 * General Input Caption
 */
export const InlineMessage = ({ message, type, id }: InlineMessageProps) => {
  return (
    <div className={wrapper}>
      {type === "error" ? (
        <AlertFilled sizeVariant={16} color="critical" role="presentation" />
      ) : (
        ""
      )}
      <Text
        id={id}
        styleVariant="caption"
        colorVariant={type === "error" ? "critical" : "secondaryText"}
        testId={id}
      >
        {message}
      </Text>
    </div>
  );
};
